export function safeStorageGet(storage, key) {
  try {
    return storage.getItem(key)
  } catch {
    return null
  }
}

export function safeStorageSet(storage, key, value) {
  try {
    storage.setItem(key, value)
  } catch {
    /* quota / private mode */
  }
}

export function safeStorageRemove(storage, key) {
  try {
    storage.removeItem(key)
  } catch {
    /* private mode */
  }
}
